import React from "react";
import { KYC_LIMIT_LABELS } from "../../../constants/kycLimits";
import useLimits from "../../../hooks/useLimits";

const LimitsInfoModal = ({ onClose }: { onClose: () => void }) => {
  const { limits } = useLimits();
  return (
    <div
      className="fixed inset-0 z-[60] flex font-manrope items-center justify-center bg-black/50 p-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md rounded-xl border border-gray-200 bg-white p-6 shadow-lg dark:border-gray-700 dark:bg-[#192025]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-4">
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[18px]">
            Trading & Withdrawal Limits
          </h4>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 text-[20px]"
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <p className="text-gray-500 dark:text-gray-400 text-[13px] mb-4">
          Limits apply per verification level.{" "}
          {KYC_LIMIT_LABELS.tradingSubtitle} and{" "}
          {KYC_LIMIT_LABELS.withdrawalSubtitle} are used for display purposes.
        </p>
        <div className="space-y-3">
          {limits.map((item) => (
            <div
              key={item.level}
              className="rounded-lg border border-gray-200 bg-gray-50 p-3 dark:border-gray-600 dark:bg-gray-800/50"
            >
              <h5 className="text-gray-900 dark:text-gray-100 font-medium text-[14px]">
                Level {item.level}
              </h5>
              <p className="text-gray-500 dark:text-gray-400 text-[13px] mt-1">
                ${item.trading} trading • ${item.withdrawal} withdrawal
              </p>
            </div>
          ))}
        </div>
        <button
          onClick={onClose}
          className="mt-6 w-full h-[44px] rounded-xl bg-secondary_button text-white font-semibold text-[14px]"
        >
          Got it
        </button>
      </div>
    </div>
  );
};

export default LimitsInfoModal;
